/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const adminIntakeFormSlice = createSlice({
  name: 'adminIntakeForm',
  initialState: [] as any[],
  reducers: {
    setIntakeFormData: (state, { payload }: PayloadAction<any>) => payload,
    clearIntakeFormData: () => [],
  },
});

export const {
  setIntakeFormData,
  clearIntakeFormData,
} = adminIntakeFormSlice.actions;

export default adminIntakeFormSlice.reducer;
export const selectIntakeForm = (state: any) => state.intakeForm;
